module.exports = __webpack_public_path__ + "img/meta_jp.5e070b0.jpg";